import React, { useState } from 'react';
import { useWeb3 } from '../../context/Web3Context';
import { shortAddress } from '../../utils/format';
import { detectProvider, isMobile } from '../../utils/wallet';
import WalletModal from './WalletModal';
import Button from '../Common/Button';

const ConnectButton = () => {
  const { account, connecting, connect, disconnect } = useWeb3();
  const [fallbackOpen, setFallbackOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleConnect = async () => {
    // If on mobile with no injected wallet, fall back to the deep-link picker.
    if (isMobile() && !detectProvider()) {
      setFallbackOpen(true);
      return;
    }
    // Otherwise just connect to whatever wallet is detected.
    await connect();
  };

  if (account) {
    return (
      <div style={{ position: 'relative' }}>
        <div
          className="account-pill"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div className="account-avatar" />
          <span>{shortAddress(account)}</span>
        </div>
        {menuOpen && (
          <>
            <div
              style={{ position: 'fixed', inset: 0, zIndex: 99 }}
              onClick={() => setMenuOpen(false)}
            />
            <div style={{
              position: 'absolute',
              top: 'calc(100% + 8px)',
              right: 0,
              minWidth: 200,
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-primary)',
              borderRadius: 'var(--radius-md)',
              padding: 8,
              zIndex: 100,
              boxShadow: 'var(--shadow-lg)'
            }}>
              <div style={{
                padding: '10px 12px',
                fontSize: 11,
                color: 'var(--text-muted)',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                fontFamily: 'Orbitron, sans-serif'
              }}>Wallet</div>
              <button
                onClick={() => { disconnect(); setMenuOpen(false); }}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  background: 'transparent',
                  border: 'none',
                  color: 'var(--accent-pink)',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontFamily: 'Orbitron, sans-serif',
                  fontSize: 12,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  borderRadius: 'var(--radius-sm)'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 46, 99, 0.1)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >Disconnect</button>
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <>
      <Button
        variant="primary"
        onClick={handleConnect}
        loading={connecting}
      >
        Connect Wallet
      </Button>
      <WalletModal open={fallbackOpen} onClose={() => setFallbackOpen(false)} />
    </>
  );
};

export default ConnectButton;
